import { standoutMarkerFrom } from '@libertify/ui/components/experience-page/addons/Standouts/markers';
import type { StandoutItem } from '@libertify/ui';
import type { Standouts } from '../types';

/**
 * Map the raw `Standouts` asset to the list shape: the BE standout as-is, plus
 * an id and the marker of its first source — the one a click draws. Assets
 * generated before the BE sent markers get one derived from the id, so a
 * refetch or a re-render hands back the same mark the document is showing.
 *
 * Shared by the authed hook (admin/sales) and media-player's server-side
 * loader, which read the same asset through different chains.
 */
export const parseStandouts = (standouts: Standouts | null): StandoutItem[] =>
  (standouts?.standouts ?? []).map((standout, index) => {
    const id = `standout-${index}`;
    const marker = standoutMarkerFrom(
      id,
      standout.sources?.[0]?.rough_notation,
    );
    return { ...standout, id, marker };
  });
